<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        label="Complete annual review within days:"
        prop="completeAnnualReviewWithinDays"
      >
        <el-input
          style="width: 300px"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          v-model="form.completeAnnualReviewWithinDays"
        ></el-input>
      </el-form-item>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    return {
      formName: 'AREV',
      form: {
        completeAnnualReviewWithinDays: '',
      },
      commonFormData: {},
      rules: {
        completeAnnualReviewWithinDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(
          this.form,
          'completeAnnualReviewWithinDays',
          newValue.completeAnnualReviewWithinDays,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
